import { render, staticRenderFns } from "./RagioneriaContrattiProvvisoriView.vue?vue&type=template&id=2a0c56f8&"
import script from "./RagioneriaContrattiProvvisoriView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaContrattiProvvisoriView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports